const version = "3.12.2";
const publishDates = {
  major: "2024-09-13T14:36:29.063Z",
  minor: "2025-04-15T13:47:42.642Z",
  patch: "2025-05-09T07:57:11.203Z"
};
export {
  publishDates,
  version
};
//# sourceMappingURL=version.mjs.map
